
var apiURL = "https://lk-api.actid.ru/";
var apiURL_auth = apiURL + "auth";
var apiURL_account = apiURL + "account";
var apiURL_logout = apiURL + "logout";

let apiDriver = require('./components/Actid/apiDriver').default;

export default {
  install(Vue, options) {
    Vue.prototype.$auth = {
      login: function (data) {
        apiDriver.login(data.data.email, data.data.password).then(response => {
          // console.log('login responce', response);
          if (response.token) {
            // console.log("set token", response.token);
            localStorage.setItem("token", response.token);
            data.success();
          } else {
            data.error();
          }
        }).catch(error => {
          data.error();
        });
      },
      logout: function (refresh_page) {
        apiDriver.logout().then(response => {
          // console.log('logout', response);
          localStorage.removeItem("token");
          if (refresh_page) document.location.href = "/login";
          resolve(response.data);
        }).catch(error => {
          reject(error);
        });
      }
    };
  }
};



// import VueAuth from '@websanova/vue-auth'
// import Http from '@websanova/vue-auth/drivers/http/axios.1.x'
// import Router from '@websanova/vue-auth/drivers/router/vue-router.2.x'


// let Http = {
//   _cache: null,

//   _init: function () {
//     if (!this.options.Vue.axios) {
//       return 'axios.js : Vue.axios must be set.'
//     }
//   },

//   _interceptor: function (req, res) {
//     var _this = this;

//     if (req) {
//       this.options.Vue.axios.interceptors.request.use(function (request) {
//         // console.log('call1', req)
//         req.call(_this, request);
//         return request;
//       }, function (error) {
//         // console.log('call2')
//         req.call(_this, error.request);
//         return Promise.reject(error);
//       })
//     }

//     if (res) {
//       this.options.Vue.axios.interceptors.response.use(function (response) {
//         // console.log('call3', _this)
//         res.call(_this, response);
//         return response;
//       }, function (error) {
//         // console.log('call4')
//         if (error && error.response) {
//           res.call(_this, error.response);
//         }

//         return Promise.reject(error);
//       })
//     }
//   },

//   _invalidToken: function (res) {
//     if (res.status === 401) {
//       return true;
//     }
//   },

//   _httpData: function (res) {
//     return res.data || {};
//   },

//   _http: function (data) {
//     var http = this.options.Vue.axios(data);
//     http.then(data.success, data.error);
//     return http;
//   },

//   _getHeaders: function (res) {
//     return res.headers;
//   },

//   _setHeaders: function (req, headers) {
//     req.headers.common = Object.assign({}, req.headers.common, headers);
//   }
// };


// legacy
// export default {
//   install(Vue) {
//     Vue.use(VueAuth, {
//       checkAuthenticated: function (cb) {
//         console.log('checkAuthenticated')
//         if (this.watch.authenticated === null && this.currentToken) {
//           this.watch.authenticated = false;

//           if (this.options.fetchData.enabled) {
//             this.options.fetchPerform.call(this, {
//               success: cb,
//               error: cb,
//               enabled: true
//             });
//           }
//           else {
//             this.options.fetchProcess.call(this, {}, {});
//             return cb.call(this);
//           }
//         } else {
//           this.watch.loaded = true;
//           return cb.call(this);
//         }
//       },
//       tokenDefaultName: "token",
//       tokenStore: ['localStorage'],
//       auth: {
//         request: function (req, token) {
//           this.currentToken = token;
//           console.log('actidAuth request', this, req, token)
//           console.log("Vue", Vue.$store)
//           this.options.http._setHeaders.call(this, req, { token: token });
//           console.log(this.$apiDriver)
//           return token;
//         },
//         response: function (res) {
//           let token = res.data.token || this.currentToken || false;
//           console.log('actidAuth response', this, res.data, token);
//           return token;
//         }
//       },
//       http: Http,
//       router: Router,
//       loginData: {
//         url: apiURL_auth,
//         fetchUser: false,
//         redirect: '/'
//       },
//       fetchData: {
//         url: apiURL_account
//       },
//       refreshData: {
//         url: apiURL_account
//       },
//       authRedirect: {
//         path: '/login?redirect=' + encodeURIComponent(document.location.href),
//       },
//       logoutData: {
//         url: apiURL_logout,
//         redirect: '/login',
//         makeRequest: true
//       }
//     })
//   }
// };
